/**
 * Tool groups — the unit of tool assignment for agents.
 *
 * A group bundles a set of tools so an agent is granted capabilities by GROUP
 * rather than tool-by-tool. Each group is described by a definition in
 * `agent-capability-packages.ts` (label, which agents may be assigned it, and
 * an optional RBAC action that gates per-user use). An agent's assigned groups
 * are the single source of truth for what it can both SEE and USE — advertised
 * to the LLM iff assigned, executable iff advertised (and RBAC permits).
 *
 * Membership is resolved from two sources, unioned: a tool's own `toolGroup`
 * on its @AiAgentTool decorator (self-tagging, e.g. the REPORTING tools), and
 * the central manifest in `agent-capability-packages.ts` (for curated, cross-
 * cutting groups like SALES_HELPER whose member tools are otherwise ungrouped).
 */
export enum ToolGroup {
	/** SQL reporting tools: describe_schema, validate_query, save_report, get_report_definition, execute_query, render_view */
	REPORTING = 'reporting',
	/** API action tools: get_action_schema, execute_action */
	API_ACTIONS = 'api_actions',
	/** External client service tools: client lookup, identity verification, invoice/order/account lookups */
	EXTERNAL_CLIENT_SERVICE = 'external_client_service',
	/**
	 * The internal Sales Helper toolkit — the curated CRM tools (client/order/
	 * quote/invoice/issue/task/opportunity lookups + mutations) the system Sales
	 * Helper agent uses. System-only; not offered to user-created agents.
	 */
	SALES_HELPER = 'sales_helper',
}
